import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GlobalServicesService } from '../services/global-services.service';
import { LoginService } from '../services/login.service';
import { OtpService } from '../services/otp.service';
import { CAROUSEL } from '../shared/carousel.consts';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  @ViewChild('resetLinkEmail') resetLinkEmail: any;
 
  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,24}$/;
  infoMessage: any = {};
  btnLoading: boolean = false;
  pageLoading: boolean = false;
  redirecting: boolean = false;
  sendResetLinkState: boolean = true;
  clicked: boolean = false;
  displayInfoMessage: boolean = false;
  resetPasswordState : boolean = false;
  showNewPassword : boolean = false;
  showConfirmPassword : boolean = false;
  passwordPattern: any = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
  waitToResend: boolean = false;
  showResendLink: boolean = false;
  otpTimer: number = 0;
  countdown: string = '';
  emailToVerify: string = '';
  reset_token: string = '';

  passwordForm: FormGroup;

  confirmPassShow: boolean = false;
  passwordLevel = {
    hasMinLength: false,
    hasSpecialCharacter: false,
    hasUpperCase: false,
    level: 0
  }

  constructor(private otpService: OtpService,private fb: FormBuilder, private loginService: LoginService, private globalService: GlobalServicesService, private router: Router, private messageService: MessageService,private confirmationService: ConfirmationService, private activatedRoute: ActivatedRoute,) { 
    this.passwordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/)]],
      confirmPassword: ['', [Validators.required]],
    }, { validator: this.passwordMatchValidator });

    this.passwordForm.get("newPassword")?.valueChanges.pipe(takeUntil(this.unsub$)).subscribe((val) => {
      const hasMinLength = val.length >= 8;
      const hasSpecialCharacter = /[!@#$%^&*%]/.test(val);
      const hasUpperCase = /[A-Z]/.test(val);
      const level = [hasMinLength, hasSpecialCharacter, hasUpperCase].filter(Boolean).length;

      this.passwordLevel = {
        hasMinLength,
        hasSpecialCharacter,
        hasUpperCase,
        level
      };
    })
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    if (newPassword === confirmPassword) {
      formGroup.get('confirmPassword')?.setErrors(null);
      return null;
    } else {
      formGroup.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }
  }

  ngOnInit(): void {
    if (this.router.url.includes('reset-password')) {
      this.activatedRoute.queryParamMap.subscribe(async (params) => {
        this.reset_token = params.get('reset_token') || '';
      });
      this.resetPasswordState = true;
    }

    if(this.loginService.loginEmail.value) {
      this.emailToVerify = this.loginService.loginEmail.value;
    } 
  }

  sendResetLinkByEmail = () => {
    if (this.waitToResend) return;

    this.btnLoading = true;
    const payload = { email: this.emailToVerify.toLowerCase() };

    this.otpService.sendForgotPasswordFastApi(payload).subscribe({
        next: (response) => {
            this.btnLoading = false;
            // this.infoMessage = { icon: 'pi pi-check', message: response.body.detail, bgColor: '#55BA45' };
            // this.showInfoMessage();
            this.messageService.add({ severity: "success", summary: "Success", detail: response.body.detail })
            this.showResendLink = true;
            this.startOtpTimer();
        },
        error: () => {
            this.btnLoading = false;
            this.displayInfoMessage = false;
        }
    });
};
  startOtpTimer() {
    this.otpTimer = 60;
    this.countdown = this.formatTime(this.otpTimer);
    this.waitToResend = true;

    const intervalId = setInterval(() => {
        this.otpTimer--;
        this.countdown = this.formatTime(this.otpTimer);

        if (this.otpTimer === 0) {
            clearInterval(intervalId);
            this.waitToResend = false;
        }
    }, 1000);
}
formatTime(seconds: number): string {
  return `${seconds.toString().padStart(2, '0')}`;
}
showInfoMessage = () => {
  this.displayInfoMessage = true;
  setTimeout(() => {
      this.displayInfoMessage = false;
      this.infoMessage = {};
  }, 10000);
};


  showToggle(passwordInputClass: string, toggleButton: string)
  {
    let passwordInput: any = document.getElementsByClassName(passwordInputClass)[0];
    if (!passwordInput) { return; }
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      toggleButton == 'newPassword' ? this.showNewPassword = true : this.showConfirmPassword = true;
    } else {
      passwordInput.type = "password";
      toggleButton == 'newPassword' ? this.showNewPassword = false : this.showConfirmPassword = false;
    }
  }

  confirm() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to reset your password?',
        accept: () => {
            this.resetPassword()
        }
    });
  }

  resetPassword(){
    this.btnLoading = true;
    let payload = {
      password : this.passwordForm.get('newPassword')?.value,
      confirm_password : this.passwordForm.get('confirmPassword')?.value
    }
    this.loginService.resetPasswordFastApi(this.reset_token,payload).subscribe({
      next: (response) => {
        this.btnLoading = false;
        if(response.status == 200){
          this.globalService.commonGrowl.next({ severity: "success", summary: "Success", detail: response.body.detail })
          this.redirectLogin();
        }
      },
      error: () => {
        this.btnLoading = false;
      }
    });
  }

  redirectLogin(){
    this.redirecting = true;
    setTimeout(() => {
      this.redirecting = false;
      this.router.navigateByUrl('/login')
    }, 100)
  }

  goBack() {
    this.router.navigateByUrl('/login')
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }
}
